import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Scrollbars from '@uie/react-custom-scrollbar';
import { colors } from '@vds-core/theme';

var ScrollView = /*#__PURE__*/function (_Component) {
  _inherits(ScrollView, _Component);

  var _super = _createSuper(ScrollView);

  function ScrollView(_props) {
    var _this;

    _classCallCheck(this, ScrollView);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "_handleUpdate", function (values) {
      var top = values.top,
          scrollHeight = values.scrollHeight,
          clientHeight = values.clientHeight;

      _this.setState({
        top: top,
        scrollHeight: scrollHeight,
        clientHeight: clientHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_thumbHeight", function () {
      var _this$state = _this.state,
          clientHeight = _this$state.clientHeight,
          scrollHeight = _this$state.scrollHeight;
      return scrollHeight ? parseInt(clientHeight * _this.state.clientHeight / scrollHeight) : 0;
    });

    _defineProperty(_assertThisInitialized(_this), "_changeBackground", function () {
      _this.setState({
        hover: !_this.state.hover
      });
    });

    _defineProperty(_assertThisInitialized(_this), "View", function (_ref) {
      var style = _ref.style,
          props = _objectWithoutProperties(_ref, ["style"]);

      var viewStyle = {
        marginRight: -15,
        paddingRight: 63,
        overflowX: 'hidden',
        height: '100%'
      };
      return /*#__PURE__*/React.createElement("div", _extends({
        id: "scrollbar-view",
        style: _objectSpread(_objectSpread({}, style), viewStyle)
      }, props));
    });

    _defineProperty(_assertThisInitialized(_this), "Track", function (_ref2) {
      var style = _ref2.style,
          props = _objectWithoutProperties(_ref2, ["style"]);

      var hideScroll = _this._thumbHeight() >= _this.state.clientHeight;

      var trackStyle = {
        backgroundColor: colors.coolGray3,
        display: hideScroll ? 'none' : 'block',
        margin: '0px 22px',
        top: 0,
        right: 0,
        bottom: 0,
        width: 4,
        cursor: 'pointer'
      };
      return /*#__PURE__*/React.createElement("span", _extends({
        id: "scrollbar-track",
        style: _objectSpread(_objectSpread({}, style), trackStyle),
        onMouseOver: _this._changeBackground,
        onMouseOut: _this._changeBackground
      }, props));
    });

    _defineProperty(_assertThisInitialized(_this), "Thumb", function (_ref3) {
      var style = _ref3.style,
          props = _objectWithoutProperties(_ref3, ["style"]);

      var hover = _this.state.hover;
      var grabZoneStyle = {
        left: '-22px',
        top: 0,
        bottom: 0,
        width: 48,
        cursor: 'pointer',
        textAlign: 'center'
      };
      var thumbStyle = {
        backgroundColor: hover ? colors.coolGray10 : colors.coolGray6,
        height: '100%',
        width: 4,
        left: '22px'
      };
      return /*#__PURE__*/React.createElement("span", _extends({
        id: "grab-zone",
        style: _objectSpread(_objectSpread({}, style), grabZoneStyle),
        onMouseOver: _this._changeBackground,
        onMouseOut: _this._changeBackground
      }, props), /*#__PURE__*/React.createElement("span", _extends({
        id: "scrollbar-thumb",
        style: _objectSpread(_objectSpread({}, style), thumbStyle)
      }, props)));
    });

    _this.state = {
      clientHeight: 0,
      scrollHeight: 0,
      hover: false,
      top: 0,
      scroll: false
    };
    _this.scrollRef = null;
    return _this;
  }

  _createClass(ScrollView, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state2 = this.state,
          scrollHeight = _this$state2.scrollHeight,
          clientHeight = _this$state2.clientHeight;

      if (prevState.scrollHeight !== scrollHeight || prevState.clientHeight !== clientHeight) {
        this.props.calculateHeight && this.props.calculateHeight(scrollHeight);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.calculateHeight && this.props.calculateHeight(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(Scrollbars, _extends({
        id: "scrollview",
        ref: function ref(el) {
          return _this2.scrollRef = el;
        },
        renderView: this.View,
        renderTrackVertical: this.Track,
        renderThumbVertical: this.Thumb,
        renderTrackHorizontal: function renderTrackHorizontal(_ref4) {
          var style = _ref4.style,
              props = _objectWithoutProperties(_ref4, ["style"]);

          return /*#__PURE__*/React.createElement("span", null);
        },
        renderThumbHorizontal: function renderThumbHorizontal(_ref5) {
          var style = _ref5.style,
              props = _objectWithoutProperties(_ref5, ["style"]);

          return /*#__PURE__*/React.createElement("span", null);
        },
        onUpdate: this._handleUpdate
      }, this.props), this.props.children);
    }
  }]);

  return ScrollView;
}(Component);

export default ScrollView;